import React from 'react';
import {Line, Bar} from "react-chartjs-2";

import {
    chart1_2_options,
    chartExample3
}                       from "variables/charts.js";
import Moment           from 'moment';
import { extendMoment } from 'moment-range/dist/moment-range.js';
import Button
                        from 'reactstrap/es/Button';


class SalesChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Labels: []
        }

        this.salesChart = {
            all: canvas => {
                let ctx = canvas.getContext("2d");

                let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

                gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
                gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
                gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

                return {
                    labels: this.state.Labels,
                    datasets: [
                        {
                            label: "All Sales",
                            fill: true,
                            backgroundColor: gradientStroke,
                            borderColor: "#1f8ef1",
                            borderWidth: 2,
                            borderDash: [],
                            borderDashOffset: 0.0,
                            pointBackgroundColor: "#1f8ef1",
                            pointBorderColor: "rgba(255,255,255,0)",
                            pointHoverBackgroundColor: "#1f8ef1",
                            pointBorderWidth: 20,
                            pointHoverRadius: 4,
                            pointHoverBorderWidth: 15,
                            pointRadius: 4,
                            data: this.getAllData()
                        }
                    ]
                };
            },
            rep: canvas => {
                let ctx = canvas.getContext("2d");

                let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

                gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
                gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
                gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

                let chartData = this.getRepData(gradientStroke);
                //generate some fake data to use in the data set


                return {
                    labels: this.state.Labels,
                    datasets: chartData
                };
            },
            state: canvas => {
                let ctx = canvas.getContext("2d");

                let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

                gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
                gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
                gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

                return {
                    labels: this.state.Labels,
                    datasets: this.getStateData(gradientStroke)
                };
            },
            options: chart1_2_options
        };
        this.moment = extendMoment(Moment);
        this.repReference = React.createRef();
    }

    getStateColour = (state) => {
        switch(state.toLowerCase()) {
            case 'act':
                return '#ffd700';
            case 'queensland':
                return '#800000';
            case 'new south wales':
                return '#00BFFF';
            case 'northern territory':
                return '#cc7722';
            case 'south australia':
                return '#0000FF';
            case 'tasmania':
                return '#006a4e';
            case 'western australia':
                return '#000000';
            case 'victoria':
                return '#C0C0C0';
            default:
                return '#'+Math.random().toString(16).slice(-6);
        }
    }


    getStateData = (gradientStroke) => {
        var labels = [];
        var l = [];
        //format labels
        switch(this.props.interval) {
            case 'hours':
                var range1 = this.moment.range(this.props.dateStart, this.props.dateEnd);
                //generate an array of every hour from start to end date
                l = Array.from(range1.by('h'));
                break;
            case 'daily':
                var de = Moment(this.props.dateEnd).add(1, 'days');
                var range1 = this.moment.range(this.props.dateStart, de);
                l = Array.from(range1.by('d'));
                break;
            case 'weekly':
                var de = Moment(this.props.dateEnd).add(1, 'week');
                var range1 = this.moment.range(this.props.dateStart, de);
                l  = Array.from(range1.by('w'));
                break;
            case 'monthly':
                var de = Moment(this.props.dateEnd).add(1, 'month');
                var range1 = this.moment.range(this.props.dateStart, de);
                l = Array.from(range1.by('M'));
                break;
        }

        l.forEach( i => {
            labels.push(i.format('YYYY-MM-DD HH:00'));
        });

        if (this.state.Labels.join(' ') != labels.join(' ')) {
            this.setState({Labels: labels});
        }

        var stateData = [];


        for (var d = 0; d < this.props.data.length; d++) {
            const wonTime = Moment(this.props.data[d].WonTime)
            var v = []
            if (!stateData[this.props.data[d].State]) {
                //set some default props
                for (var i = 0; i < l.length; i++) {
                    v.push(0)
                }
                stateData[this.props.data[d].State] = {
                    label: this.props.data[d].State,
                        fill: true,
                    backgroundColor: gradientStroke,
                    borderColor: this.getStateColour(this.props.data[d].State),
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: this.getStateColour(this.props.data[d].State),
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#1f8ef1",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    data: []
                }

            } else {
                v = stateData[this.props.data[d].State].data;
            }

            if (l.length == 1) {
                //we only have 1 date so we just do it all
                v[0] = this.props.type == 'count' ? v[0] + 1 : v[0] + this.props.data[d].DealValue;
            } else {
                for (var i = 1; i < l.length; i++) {
                    if (wonTime.isBefore(l[i]) && wonTime.isAfter(l[i - 1])) {
                        v[i - 1] = this.props.type == 'count' ? v[i - 1] + 1 : v[i - 1] + this.props.data[d].DealValue;
                    }
                }
            }
            stateData[this.props.data[d].State].data = v;
        }
        var retData = [];
        Object.keys(stateData).forEach(k => {
            retData.push(stateData[k]);
        })
        return retData;
    }

    getRepData = (gradientStroke) => {
        var labels = [];
        var l = [];
        //format labels
        switch(this.props.interval) {
            case 'hours':
                var range1 = this.moment.range(this.props.dateStart, this.props.dateEnd);
                //generate an array of every hour from start to end date
                l = Array.from(range1.by('h'));
                break;
            case 'daily':
                var de = Moment(this.props.dateEnd).add(1, 'days');
                var range1 = this.moment.range(this.props.dateStart, de);
                l = Array.from(range1.by('d'));
                break;
            case 'weekly':
                var de = Moment(this.props.dateEnd).add(1, 'week');
                var range1 = this.moment.range(this.props.dateStart, de);
                l  = Array.from(range1.by('w'));
                break;
            case 'monthly':
                var de = Moment(this.props.dateEnd).add(1, 'month');
                var range1 = this.moment.range(this.props.dateStart, de);
                l = Array.from(range1.by('M'));
                break;
        }

        l.forEach( i => {
            labels.push(i.format('YYYY-MM-DD HH:00'));
        });

        if (this.state.Labels.join(' ') != labels.join(' ')) {
            this.setState({Labels: labels});
        }

        var repData = []
        //loop over all the reps that are sent, if their team has "sale" in it, they are now being reported on
        for (var i = 0; i < this.props.reps.length; i++) {
            if (this.props.reps[i].TeamName.toLowerCase().includes('sales')) {
                var colour = this.props.reps[i].Color == '#000000' ? '#'+Math.random().toString(16).slice(-6) : this.props.reps[i].Color;
                repData[this.props.reps[i].ExternalUserID + ''] = {
                        label: this.props.reps[i].UserName,
                        fill: true,
                        backgroundColor: gradientStroke,
                        borderColor: colour,
                        borderWidth: 2,
                        borderDash: [],
                        borderDashOffset: 0.0,
                        pointBackgroundColor: colour,
                        pointBorderColor: "rgba(255,255,255,0)",
                        pointHoverBackgroundColor: "#1f8ef1",
                        pointBorderWidth: 20,
                        pointHoverRadius: 4,
                        pointHoverBorderWidth: 15,
                        pointRadius: 4,
                        data: []
                    }
            }
        }
        repData['Unknown'] = {
            label: 'Non Sales',
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: '#'+Math.random().toString(16).slice(-6),
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#1f8ef1",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#1f8ef1",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: []
        }
        //default all reps to 0 everything
        for (var i = 0 ; i < l.length; i++) {
            Object.keys(repData).forEach( k => {
                repData[k].data[i] = 0;
            })
        }

        for (var d = 0; d < this.props.data.length; d++) {
            const wonTime = Moment(this.props.data[d].WonTime)

            var thisRepData = repData[this.props.data[d].RepID] ? repData[this.props.data[d].RepID] : repData['Unknown'];
            var v = thisRepData.data;
            if (l.length == 1) {
                //we only have 1 date so we just do it all
                v[0] = this.props.type == 'count' ? v[0] + 1 : v[0] + this.props.data[d].DealValue;
            } else {
                for (var i = 1; i < l.length; i++) {
                    if (wonTime.isBefore(l[i]) && wonTime.isAfter(l[i - 1])) {
                        v[i - 1] = this.props.type == 'count' ? v[i - 1] + 1 : v[i - 1] + this.props.data[d].DealValue;
                    }
                }
            }
            if (repData[this.props.data[d].RepID]) {
                repData[this.props.data[d].RepID].data = v;
            } else {
                repData['Unknown'].data = v;
            }
        }
        var returnArray = [];
        Object.keys(repData).forEach(k => {
            var hasData = false;
            repData[k].data.forEach(i => {
                if (i !== 0) {
                    hasData = true;
                }
            });
            if (hasData) {
                returnArray.push(repData[k]);
            }

        });
        return returnArray;
    }

    getAllData = () => {
        var labels = [];
        var l = [];
        //format labels

        switch(this.props.interval) {
            case 'hours':
                var range1 = this.moment.range(this.props.dateStart, this.props.dateEnd);
                //generate an array of every hour from start to end date
                l = Array.from(range1.by('h'));
                break;
            case 'daily':
                var de = Moment(this.props.dateEnd).add(1, 'days');
                var range1 = this.moment.range(this.props.dateStart, de);
                l = Array.from(range1.by('d'));
                break;
            case 'weekly':
                var de = Moment(this.props.dateEnd).add(1, 'week');
                var range1 = this.moment.range(this.props.dateStart, de);
                l  = Array.from(range1.by('w'));
                break;
            case 'monthly':
                var de = Moment(this.props.dateEnd).add(1, 'month');
                var range1 = this.moment.range(this.props.dateStart, de);
                l = Array.from(range1.by('M'));
                break;
        }

        l.forEach( i => {
            labels.push(i.format('YYYY-MM-DD HH:00'));
        });

        if (this.state.Labels.join(' ') != labels.join(' ')) {
            this.setState({Labels: labels});
        }
        var v = []
        for (var i = 0 ; i < l.length; i++) {
            v[i] = 0;
        }

        //loop over all the l array moment items
        //if the time is less than the index it applies here
        //just add the value if the type is value otherwise we add the count
        for (var d = 0; d < this.props.data.length; d++) {
            const wonTime = Moment(this.props.data[d].WonTime)

            if (l.length == 1) {
                if (v.length == 0) {
                    v[0] = 0;
                }
                //we only have 1 date so we just do it all
                v[0] = this.props.type == 'count' ? v[0] + 1 : v[0] + this.props.data[d].DealValue;
            } else {
                for (var i = 1; i < l.length; i++) {
                    if (wonTime.isBefore(l[i]) && wonTime.isAfter(l[i - 1])) {
                        v[i - 1] = this.props.type == 'count' ? v[i - 1] + 1 : v[i - 1] + this.props.data[d].DealValue;
                    }
                }
            }
        }

        return v;
    }

    toggleReps = () => {
        if (this.repReference) {
            this.repReference.current.chartInstance.data.datasets.forEach(function(ds) {
                ds.hidden = !ds.hidden;
            });
            this.repReference.current.chartInstance.update();
        }
    }


    render() {
        return (
            <>
                {
                    this.props.view === 'all' &&
                        <div className={`chart-area sales-chart-area`}>
                            <Line
                                data={this.salesChart.all}
                                options={chart1_2_options}
                            />
                        </div>
                }
                {
                    this.props.view === 'rep' &&
						<>
							<Button className={`center-button`} onClick={this.toggleReps} size={'sm'}>Show/Hide</Button>
							<div className={`chart-area sales-chart-area`}>
								<Line
									ref={this.repReference}
									data={this.salesChart.rep}
									//options={chartExample3.options}
									options={chartExample3.options}
									/>
							</div>
						</>
                }
                {
                    this.props.view === 'state' &&
                        <div className={`chart-area sales-chart-area`}>
                            <Line
                                data={this.salesChart.state}
                                //options={chartExample3.options}
                                options={chart1_2_options}
                            />
                        </div>
                }
            </>
        )
    }
}

export default SalesChart;